// Tunable constants for the homepage hero ranking. Single source of truth.
// Change a number here, the whole hero adapts. No component edits needed.

export const POPULARITY = {
  weights: {
    /** What everyone is doing (anonymous, site-wide). */
    global: 0.55,
    /** What THIS visitor is doing (localStorage only). */
    personal: 0.45,
  },
  /** Raw points per signal — mirrored on server for global writes. */
  points: {
    project_view: 10,
    project_dwell: 6,
    filter_match: 8,
    hero_click: 12,
    hero_hover: 4,
    repeat_project: 6,
    repeat_sector: 3,
  } as const,
  recency: {
    /** Signals newer than this get the boost multiplier. */
    boostDays: 7,
    boostX: 1.2,
    /** Decay floor for older signals up to 90 days. */
    decayFloor: 0.6,
    horizonDays: 90,
  },
  caps: {
    /** Per browser session. */
    perKindPerSession: 5,
  },
  dwellMinSeconds: 8,
  hoverThresholdMs: 1500,
} as const;

export const HERO = {
  intervalMs: 8000,
  poolSize: 60,
  /** When local signals < this AND global empty → cold start. */
  coldStartSignalThreshold: 3,
} as const;


export const DIVERSITY = {
  noBackToBackProject: true,
  /** No same project repeats within the last N picks of the rotation. */
  projectRepeatWindow: 38,

  /** Soft penalty if same sector appears consecutively. */
  sameSectorRunPenalty: 0.5,
  /** Cap any single sector at 40% of the rotation. */
  maxSectorShareOfRotation: 0.4,
  /** Always include ≥1 in-progress project per N. */
  inProgressEveryN: 6,
  recentShownPenalty: 0.6,
  recentShownMemory: 8,
} as const;

export const QUALITY = {
  inProgressPenalty: -0.15,
  mobileUnsafePenalty: -0.1,
} as const;
